export const formatCurrency = (price: unknown, options: Intl.NumberFormatOptions | undefined = undefined): string => {
  const parsedPrice = typeof price === 'string' ? parseFloat(price) : typeof price !== 'number' ? 0 : price

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    ...options
  })

  return formatter.format(parsedPrice)
}
